import Vue from "vue";
import Vuex from "vuex";

import Options from "@/options";
import Numbers from "@/services/Numbers";

import auth from "./auth";
import settings from "./settings";
import coinmarketcap from "./coinmarketcap";
import portfolio from "./portfolio";
import currency from "./currency";
// import exchange from "./exchange";
import ui from "./ui";
import profitloss from "./profitloss";

Vue.use(Vuex);

const mainStore = {
  state: {},
  getters: {
    title(_state, _getter, _rootState, rootGetters) {
      const evaluation = rootGetters["portfolio/currentEvaluation"];
      const currency = rootGetters["settings/currency"];

      const noEvaluation = evaluation === 0;
      const showDefault =
        typeof currency === "undefined" ||
        noEvaluation ||
        rootGetters["settings/incognitoMode"] ||
        !rootGetters["settings/evaluationInTitle"] ||
        isNaN(evaluation);

      const valuation = Numbers.formatMoney(evaluation, currency);

      return showDefault ? "CoinTrackr" : `${valuation} - CoinTrackr`;
    },
  },
  actions: {
    initState({ commit, dispatch }, payload) {
      if (!payload) {
        return;
      }

      if (payload.settings) {
        for (let setting in payload.settings) {
          dispatch(
            "settings/setSetting",
            {
              setting,
              value: payload.settings[setting],
            },
            { root: true }
          );
        }
      }
      if (payload.assets) {
        dispatch(
          "portfolio/setAssets",
          { assets: payload.assets },
          { root: true }
        );
      }
      if (payload.assetsLocal) {
        dispatch("portfolio/setAssetsLocal", payload.assetsLocal, {
          root: true,
        });
      }
      // if (payload.exchange) {
      //   commit("exchange/setIsLoggedIn", payload.exchange.isLoggedIn, {
      //     root: true,
      //   });
      //   commit("exchange/setTokens", payload.exchange, { root: true });
      // }
      if (payload.profitloss && payload.profitloss.assets) {
        dispatch(
          "profitloss/setAssets",
          { assets: payload.profitloss.assets },
          {
            root: true,
          }
        );
      }
      if (payload.profitloss && payload.profitloss.transactions) {
        dispatch(
          "profitloss/setTransactions",
          {
            transactions: payload.profitloss.transactions,
          },
          {
            root: true,
          }
        );
      }
    },
  },
};

const store = new Vuex.Store({
  ...mainStore,
  modules: {
    auth,
    settings,
    coinmarketcap,
    portfolio,
    ui,
    currency,
    // exchange,
    profitloss,
  },
});

// initial state loading from localStorage
const stateKeyInLS = Options.stateKeyInLS;
if (localStorage.getItem(stateKeyInLS)) {
  try {
    const newState = JSON.parse(localStorage.getItem(stateKeyInLS));
    store.dispatch("initState", newState);
  } catch (e) {}
}
const saveableState = (state) => ({
  settings: state.settings,
  assets: state.portfolio.assets,
  assetsLocal: state.portfolio.assetsLocal,
  // exchange: {
  //   isLoggedIn: state.exchange.isLoggedIn,
  //   access_token: state.exchange.accessToken,
  //   refresh_token: state.exchange.refreshToken,
  // },
  profitloss: {
    assets: state.profitloss.assets,
    assetsLocal: state.profitloss.assetsLocal,
    transactions: state.profitloss.transactions,
    transactionsLocal: state.profitloss.transactionsLocal,
  },
});
const saveToLocalStorage = (state) => {
  localStorage.setItem(stateKeyInLS, JSON.stringify(state));
};
store.watch(saveableState, saveToLocalStorage, { deep: true });

export default store;
